'use strict';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {getPeopleSelectorList} from '../reducers/state';
import {buildPeopleList, REDUX_OPTIONS} from './peopleConfig';
import {PEOPLE_SELECTOR_LIST_PREFIX} from './state';

// TODO: we will need to insert additional params/filterOptions data into list requests to retrieve the targeted people list
// either the options will need to be modified in some way, or we may need to customize the request factories
// it may suffice to implement some way of automatically starting off in the filtered state and set the filterOptions
// in any case, we want to eliminate the possibility of the list system making a full request and then immediately cancelling it and requesting the filtered state.

/** @type {ReduxList} */
export const reduxList = buildPeopleList({
  prefix: PEOPLE_SELECTOR_LIST_PREFIX,
  getState: getPeopleSelectorList,
  listPath: parentId => `organizations/${parentId}/people`,
  listSyncPath: parentId => `organizations/${parentId}/people/${SYNC_PATH}`,
  useDelete: false,
  useFilterOptions: true,
  defaultFilterOptions: {
    includeTeams: true,
    expandTeams: false,
    includeUsers: true,
    includeNonUsers: true,
  },
});

export const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options, {
  ...REDUX_OPTIONS,
  excludeFilterModalOptions: true,
  useInitFilter: true,
});



// WEBPACK FOOTER //
// ./src/js/personnel/redux/peopleSelectorList.js